module.exports = __webpack_public_path__ + "static/media/backbutton.002fc467.png";